// This file is automatically generated. Do not edit manually.

import { AavoObjectRef } from "src/api/generated/common/aavoObject/aavoObjectRef";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SendDocumentsViewApi {
	export async function getInitData(args: {
		objectRef: AavoObjectRef | null | undefined;
	}): Promise<SendDocumentsViewApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/documents/sendDocumentsView/getInitData",
			method: "POST",
			data: {
				objectRef: args.objectRef,
			},
		});
		return response as SendDocumentsViewApi_InitData;
	}
}

export interface SendDocumentsViewApi_InitData {
	defaultReceiverEmail: string;
	emailSignature: string;
}
